<template lang="pug">
//- 查詢中先隱藏提示框，查回後才顯示，避免先畫出預設值或上一筆的資料再跳成正確內容
Poptip(:title="$t('certsmanage.explainPoptipTitle')" transfer :popper-class="isLoading ? 'wildcard-csr-poptip-is-loading' : ''" @on-popper-show="get")
    template(slot="content")
        div(v-if="isSupportedProvider" style="display: flex; flex-direction: column")
            p {{ $t("certsmanage.explainPoptipContentForWildcard") }}
            h4 Host
            CopyText(style="margin-bottom: 8px" :text="cnameHost" :copyText="cnameHost")
            h4 Value
            div(v-for="(item, index) in cnameValues" :key="index")
                CopyText(:text="item" :copyText="item")
        p(v-else) {{ $t("certsmanage.wildcardProviderNotSupported") }}
    Icon(:type="iconType", :size="24", :color="iconColor")
</template>

<script>
import { getWildcardCSRHost } from "@/api/certs";

export default {
    name: "WildcardCsrPoptip",
    props: {
        params: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            cnameHost: "",
            cnameValues: [],
            isSupportedProvider: true,
            isLoading: true,
        };
    },
    methods: {
        async get() {
            this.isLoading = true;
            try {
                // host
                const { groupName, servername, cnameto, sslProvider } = this.params.row;
                const response = await getWildcardCSRHost({ groupName, sslProvider });
                const { CNAME_Host } = response.data.data || {};
                // 憑證廠商沒有 wildcard 驗證用的 Host（目前只有 Sectigo 有），不顯示 Host / Value
                this.isSupportedProvider = !!CNAME_Host;
                // _wildcard.abc.com → _pki-validation.abc.com，與 acme 檢查的紀錄一致
                this.cnameHost = CNAME_Host ? servername.replace("_wildcard", CNAME_Host) : "";
                // value
                const SSL_VALIDATION_PREFIX = "_pki_";
                this.cnameValues = cnameto.map((item) => `${SSL_VALIDATION_PREFIX}${item}`);
            } catch (error) {
                console.error("Failed to get CSR", error);
            } finally {
                this.isLoading = false;
            }
        },
    },
    computed: {
        iconType() {
            return this.params.row.hasSystemCert ? "ios-information-circle-outline" : "md-warning";
        },
        iconColor() {
            return this.params.row.hasSystemCert ? "grey" : "orange";
        },
    },
};
</script>

<style>
/* 提示框 transfer 到 body，scoped 樣式套不到，用全域 class */
.wildcard-csr-poptip-is-loading {
    visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/FormItems/WildcardCSRPoptip.vue